import "../assets/css/error.css"

export default function Error({data}) {
    return(
        <div id="main-site">
            <div className="fof">
                <h1>{data.status}</h1>
                <p>انجام عملیات با خطای زیر مواجه شد!</p>
                <p>{JSON.stringify(data.data.message)}</p>
                <a href="/" className="btn btn-primary">بازگشت به صفحه اصلی</a>
            </div>
        </div>
    )
}